import { styled } from 'styled-components';
import { classic } from '~/themes';

type IProps = {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

type TProps = IProps;

export function ButtonNext({ children, onClick, disabled }: TProps) {
  return (
    <Container
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick(e);
      }}
    >
      <SDivContent $disabled={disabled}>
        <SSpan>{children}</SSpan>
      </SDivContent>
    </Container>
  );
}

const SSpan = styled.span<{ $isTimeOut?: boolean }>`
  color: ${({ $isTimeOut }) =>
    $isTimeOut
      ? `${classic.token?.colorError}`
      : `${classic.token?.colorWhite}`};
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.6rem;

  @media screen and (max-height: 800px) {
    font-size: 1.3rem;
  }

  @media screen and (max-height: 450px) {
    font-size: 1.1rem;
  }

  @media screen and (max-width: 450px) {
    font-size: 1.1rem;
  }
`;

const Container = styled.button<{ disabled?: boolean }>`
  align-items: center;
  border-radius: 20px;
  border: 3px solid white;
  background-color: #b0b0b0;
  display: flex;
  justify-content: center;
  cursor: pointer;
  opacity: ${({ disabled }) => {
    if (disabled) return 0.5;
    return 1;
  }};
  pointer-events: none;
  user-select: none;
  transition: all 0.3s linear;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  overflow: hidden;
  z-index: 300;
  height: 50px;
  bottom: -25px;

  position: absolute;
  left: 80%;
  transform: translateX(-50%);

  @media screen and (max-width: 450px) {
    height: 42px;
    bottom: -25px;
  }
  @media screen and (max-height: 800px) {
    height: 42px;
    bottom: -25px;
  }
`;

const SDivContent = styled.div<{ $disabled?: boolean }>`
  align-items: center;
  display: flex;
  border-radius: 20px;
  justify-content: center;
  background-color: ${({ $disabled }) => ($disabled ? '#EA7A4980' : '#EA7A49')};
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.25) inset;
  padding: 0 20px;
  height: 68px;

  @media screen and (max-width: 450px) {
    height: 38px;
  }
  @media screen and (max-height: 800px) {
    height: 38px;
  }
`;
